import { render, staticRenderFns } from "./NbQuizSuperAdminPreSelect.vue?vue&type=template&id=93d3577c"
import script from "./NbQuizSuperAdminPreSelect.vue?vue&type=script&lang=js"
export * from "./NbQuizSuperAdminPreSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports